/**
 * @description Получает на вход статус {number} и возвращает его текстовое значение
 * @nosideeffects
 * @param status
 */
const retrieveStatus = /* #__PURE__ */ (status: number) => {
  switch (status) {
    case 1:
      return 'Черновик';
    case 2:
      return 'Запланированное';
    case 3:
      return 'Активное';
    case 4:
      return 'Завершённое';
    case 5:
    default:
      return 'Отменённое';
    case 6:
      return 'Отправлено';
  }
};

/**
 * @description Получает на вход статус {number} и возвращает его текстовое значение для награды
 * @nosideeffects
 * @param status
 */
const retrieveStatusAwardPlace = /* #__PURE__ */ (status: number) => {
  switch (status) {
    case 2:
      return 'Доступен для выбора';
    case 3:
      return 'Выбран';
    case 4:
      return 'Выдано';
    case 5:
      return 'Выдача приостановлена';
    case 6:
      return 'Отправлено';
    case 7:
      return 'Отменено';
  }
};

export { retrieveStatus, retrieveStatusAwardPlace };
